package com.crowpay.views.components.project.work.payApps

import com.crowpay.PayAppItem
import com.crowpay.PayApplication
import com.crowpay.utils.renderDollars
import com.crowpay.views.components.tableEntryMoney
import com.crowpay.views.components.tableEntry
import com.crowpay.views.screens.common.ProjectView
import com.crowpay.views.theming.AppColors
import com.crowpay.views.theming.ApprovedSemantic
import com.crowpay.views.theming.DeniedSemantic
import com.crowpay.views.theming.DisplayableStateSemantic
import com.crowpay.views.theming.body
import com.crowpay.views.theming.bodyBold
import com.crowpay.views.theming.boldSubTitle
import com.crowpay.views.theming.colored
import com.crowpay.views.theming.lightSection
import com.lightningkite.kiteui.models.EmphasizedSemantic
import com.lightningkite.kiteui.reactive.Readable
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.reactive.shared
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.centered
import com.lightningkite.kiteui.views.direct.col
import com.lightningkite.kiteui.views.direct.link
import com.lightningkite.kiteui.views.direct.row
import com.lightningkite.kiteui.views.dynamicTheme
import com.lightningkite.kiteui.views.expanding

fun ProjectView.renderPayAppCard(
    payApp: Readable<PayApplication>,
    items: Readable<List<LineItemWithPaymentInfo>>,
    writer: ViewWriter,
) = with(writer) {
    val status = shared {
        items().mapNotNull { it.payApp?.status }.toSet().overallStatus()
    }

    lightSection - link {
        col {
            row {
                centered - expanding - boldSubTitle {
                    ::content { "Draw ${payApp().number}" }
                }
                centered - bodyBold {
                    dynamicTheme { DisplayableStateSemantic(status()) }
                    ::content { status().displayName }
                }
            }
//            keyValue("Items") { items().count { it.payApp != null }.toString() }
            fun List<LineItemWithPaymentInfo>.sumDraws(predicate: (PayAppItem) -> Boolean) = sumOf { it.payApp?.takeIf(predicate)?.amount ?: 0 }

            row {
                expanding - col {
                    tableEntryMoney("Work Value") { items().sumOf { it.payApp?.amount ?: 0 } }
//                    greySeparator()
                    tableEntry("Approved") {
                        (ApprovedSemantic + EmphasizedSemantic).onNext - body {
                            ::content { items().sumDraws { it.approved != null }.renderDollars() }
                        }
                    }
                }
                expanding - col {
                    tableEntry("Pending") {
                        colored(AppColors.grey.dark) - body {
                            ::content { items().sumDraws { it.pending }.renderDollars() }
                        }
                    }
//                    greySeparator()
                    tableEntry("Waited") {
                        (DeniedSemantic + EmphasizedSemantic).onNext - body {
                            ::content { items().sumDraws { it.denied != null }.renderDollars() }
                        }
                    }
                }
            }
        }
        ::to {
            if (status() == PayAppStatus.Draft) {
                { PayAppForm(payApp()._id) }
            }
            else {
                { PayAppDetails(projectId, payApp()._id, lens) }
            }
        }
    }
}